// Iter-276.G (Top-20 #20) — FilterSelect extracted from
// PartnerRateTable.jsx as part of the LoC refactor. Pure presentational
// dropdown wrapper used by the sticky-bar filter strips (insurance
// state + driver-tag) and the lender-rate-filters chip strip.

import React from "react";

export default function FilterSelect({ testid, label, value, onChange, options }) {
  return (
    <label
      data-testid={testid}
      // Iter-276.D — `shrink-0 whitespace-nowrap` keeps each FilterSelect
      // from collapsing inside the parent horizontal-scroll filter strip
      // on mobile (Top-20 #8 mobile sort+filter retention).
      className="shrink-0 inline-flex items-center gap-1.5 min-h-[36px] border border-slate-200 bg-white px-2 hover:border-slate-400 transition-colors whitespace-nowrap"
    >
      <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`${testid}-select`}
        className="bg-transparent text-slate-950 text-xs font-semibold outline-none cursor-pointer pr-1"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}
